import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ISnapshotSignRequest, SnapshotSignRequest } from "@/models/snapshot-sign-request.entity";
import snapshotSignRequestService from "@/services/mrfiktiv/services/snapshot-sign-request.service";
import { MrfiktivSnapshotSignRequestControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { SnapshotSignRequestDataAccessLayer } from "./access-layers/snapshot-sign-request.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { SnapshotSignRequestPageDataProvider } from "./page-data-provider/snapshot-sign-request.page-data-provider";

/**
 * wraps the timed event endpoint into a makeshift event pagination @see RefTypeMap
 */
@Module({
  dynamic: true,
  namespaced: true,
  name: "snapshot-sign-request",
  store
})
class SnapshotSignRequestStore extends PaginatedBaseStore<
  ISnapshotSignRequest,
  MrfiktivSnapshotSignRequestControllerFindAllParamsGen
> {
  protected _data = SnapshotSignRequestDataAccessLayer;
  protected _pageProvider = SnapshotSignRequestPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = SnapshotSignRequest.filterables;

  @Action
  public async fetchSnapshotSignRequests({ snapshotId, partnerId }: { snapshotId: string; partnerId: string }) {
    const all = await snapshotSignRequestService.getAll({
      partnerId,
      filter: [
        new PageFilterElement({
          key: "snapshotId",
          operation: PageFilterOperationEnum.EQUAL,
          value: snapshotId
        })
      ]
    });

    const allMapped = (all.data ?? []).map((ssr) => new SnapshotSignRequest(ssr));

    for (const ssrm of allMapped) {
      this._data.set(ssrm);
    }

    return allMapped;
  }

  @Action
  public async fetchHandoverSignRequests({ handoverId, partnerId }: { handoverId: string; partnerId: string }) {
    const all = await snapshotSignRequestService.getAll({
      partnerId,
      filter: [
        new PageFilterElement({
          key: "handoverId",
          operation: PageFilterOperationEnum.EQUAL,
          value: handoverId
        })
      ]
    });

    const allMapped = (all.data ?? []).map((ssr) => new SnapshotSignRequest(ssr));

    for (const ssrm of allMapped) {
      this._data.set(ssrm);
    }

    return allMapped;
  }
}

export const SnapshotSignRequestModule = getModule(SnapshotSignRequestStore);
